var map = {
	"./bg_card.png": 56474,
	"./default_activity.png": 45915,
	"./default_avatar.png": 23587,
	"./default_teacher.png": 63888,
	"./elvis-ohno.png": 25130,
	"./fort.png": 11633,
	"./logo.jpg": 50975,
	"./logo_elvis_a.png": 97033,
	"./moulin.png": 82360,
	"./picto-ziggy.svg": 39901,
	"./placeholder_pack.png": 13467,
	"./qr-code.png": 7541,
	"images/bg_card.png": 56474,
	"images/default_activity.png": 45915,
	"images/default_avatar.png": 23587,
	"images/default_teacher.png": 63888,
	"images/elvis-ohno.png": 25130,
	"images/fort.png": 11633,
	"images/logo.jpg": 50975,
	"images/logo_elvis_a.png": 97033,
	"images/moulin.png": 82360,
	"images/picto-ziggy.svg": 39901,
	"images/placeholder_pack.png": 13467,
	"images/qr-code.png": 7541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6663;